@if (mode$ | async; as mode) {
  @if (mode === 'extra-small') {
    <button (click)="toggleMenu($event)" class="menu-opener" fastTooltip="Menu" semerisIconButton>
      <mat-icon> menu </mat-icon>
    </button>
  }
  <div class="sidenav-container" (click)="onMenuClick($event)">
    <div class="sidenav-title">
      @if (logoUrl$ | async; as logo) {
        <a class="w-full" [routerLink]="link$ | async">
          <img [src]="'https://logo.assets.semeris.com/' + logo | safe" alt="Company logo" />
        </a>
      }
    </div>
    <ng-container>
      @if (assets$ | async; as options) {
        <div class="sidenav-asset-selector">
          <semeris-asset-selector [mode]="mode" [options]="options" (valueChanged)="changeAsset($event)"> </semeris-asset-selector>
        </div>
      }
    </ng-container>
    <div class="sidenav-content">
      <ng-container *hasAsset>
        <div class="menu">
          @for (item of dataSource$ | async; track item.name) {
            <semeris-sidenav-item
              [attr.id]="item?.idAttr"
              [menuNode]="item"
              [mode]="mode"
              [nextTeaserInert]="!canOpenNext"
              (menuClick)="onMenuClicked($event)"
            ></semeris-sidenav-item>
          }
        </div>
      </ng-container>
    </div>
    <div class="sidenav-footer">
      @if (mode === 'small') {
        <a href="https://semeris.com" target="_blank" rel="noopener noreferrer">
          <button fastTooltip="Semeris" semerisIconButton>
            <mat-icon> copyright </mat-icon>
          </button>
        </a>
      }
    </div>
    <div class="sidenav-extender">
      <a href="https://semeris.com" target="_blank" rel="noopener noreferrer"><p>&copy;&nbsp;Semeris</p></a>
      <button
        (click)="toggleMenu($event)"
        id="extender"
        [fastTooltip]="mode === 'small' ? 'Extend' : 'Shrink'"
        semerisIconButton
      >
        <mat-icon> chevron_right </mat-icon>
      </button>
    </div>
  </div>
}

@if (showOverlay$ | async) {
  <div class="transparent-backdrop"></div>
}
